import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";
import { baseUrl } from "./Univ.js";
import { useAuth } from "./context/AuthContext";

function ChangePassword() {
  const user_id = localStorage.getItem("user_id"); // ✅ correct key
  const [password, setPassword] = useState("");
  const { logoutUser } = useAuth();

  const formSubmit = async () => {
    if (!password) {
      Swal.fire({
        title: "Error",
        text: "Password cannot be empty",
        icon: "warning",
      });
      return;
    }

    try {
      await axios.post(
        `${baseUrl}change-pass/${user_id}/`,
        { password }, // ✅ JSON payload

      );

      Swal.fire({
        title: "Password Changed Successfully",
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });

      logoutUser();
      setTimeout(() => {
        window.location.href = "/user-login/";
      }, 2000);

    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Failed to change password",
        icon: "error",
      });
    }
  };

  return (
    <section className="container mt-4">
      <div className="row">
        <div className="col-md-3 col-12 mb-2"></div>

        <div className="col-md-9 col-12 mb-2">
          <div className="card">
            <h4 className="card-header">Change Password</h4>

            <div className="card-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

                <button
                  type="button"
                  onClick={formSubmit}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChangePassword;
